<template>
  <div class="marketing-block siteblocks siteblocks-templates hero-block">
    <div class="hero-panel panel">
      <div class="full">
        <h2 v-html="$t('sitebuilder_templates.THEME_GARDEN_HEADING')"></h2>
        <p v-html="$t('sitebuilder_templates.THEME_GARDEN_SUBHEADING')"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.ready = true
    if (window.navigator.userAgent !== 'PRERENDER') {
      // Stuff here
    }
  },
  data: () => {
    let heroImage = require(`assets/img/sitebuilder/hero-cycle/hero-image-1.png`)
    let siteblocksBrandImage = require(`assets/img/shared/siteblocks_new.svg`)
    return {
      heroImage,
      siteblocksBrandImage,
      typedTitle: true,
      ready: false,
      title: '<div/>'
    }
  },
  props: [
    'view',
    'hasCTA',
    'clickHandler',
    'href',
  ]
}
</script>